// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"77509b63","527":"151953f9","544":"ccf151b7","749":"bc99e5df"}[chunkId] + ".chunk.js";
};